import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS, environment } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { OfferCountItem, Offer } from './offer';

@Injectable({
  providedIn: 'root'
})
export class OfferServiceService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getOfferCounter(): Observable<OfferCountItem> {
    const api = (<any>_GlobalNS).api.offer.counter;
    const propertyId = this._global.find((<any>_GlobalNS).paths.PropertyId);
    const url = (environment.production) ? `${api}&PropertyId=${propertyId}` : `${api}?PropertyId=1`;

    return this._http.get<OfferCountItem>(url);
  }

  getOffers(pagination?: any, loanNumber?: string, offerStatus?: any[], loadDefault?: boolean): Observable<any> {
    const api = (<any>_GlobalNS).api.offer.allOffers;

    let params = new HttpParams();

    if (loadDefault)  {
      params = params.set('offset', pagination.offset.toString())
        .set('pageSize', pagination.pageSize)
        .set('sortValue', '')
        .set('sortDir', '');
      params = params.set('offerStatus', 'new');
    } else {
      params = params.set('offset', pagination.offset.toString())
        .set('pageSize', pagination.pageSize)
        .set('sortValue', pagination.sortValue)
        .set('sortDir', pagination.sortDir);

      if ( loanNumber && loanNumber.split(',').length > 0 ) {
        params = params.set('loanNumber', loanNumber);
      }

      if ( offerStatus && offerStatus.length > 0 ) {
        params = params.set('offerStatus', offerStatus.join(','));
      }
    }

    

    return this._http.get<any>(`${api}`, {params});
  }

  updateOffer(OfferPayload: {}): Observable<any> {
    const api = (<any>_GlobalNS).api.offer.updateOffer;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);

    return this._http.post<any>(`${api}&eqrf=${eqrf}`, OfferPayload, this.httpOptions);
  }

}
